import {
    Upload, DatePicker,Transfer,Button,Row,Col,Dialog,TimePicker, Select, Option,
    Popconfirm, Input, FormItem, Form, Card, Tabs, TabPane, Table, TableColumn, Badge, Container,
    Main, Aside, Header, Radio, RadioGroup, Divider, Switch, InputNumber, Popover,
    CheckboxGroup, Checkbox, ColorPicker, Slider, Rate, Cascader, Tree, Alert, RadioButton, Message, Pagination,TimeSelect
} from 'element-ui'
const element = {
    install: function(Vue) {
        Vue.use(Upload)
        Vue.use(DatePicker)
        Vue.use(Transfer)
        Vue.use(Button)
        Vue.use(Row)
        Vue.use(Col)
        Vue.use(Dialog)
        Vue.use(TimePicker)
        Vue.use(Select)
        Vue.use(Option)
        Vue.use(Popconfirm)
        Vue.use(Input)
        Vue.use(FormItem)
        Vue.use(Form)
        Vue.use(Card)
        Vue.use(Tabs)
        Vue.use(TabPane)
        Vue.use(Table)
        Vue.use(TableColumn)
        Vue.use(Badge)
        Vue.use(Container)
        Vue.use(Main)
        Vue.use(Aside)
        Vue.use(Header)
        Vue.use(Radio)
        Vue.use(RadioGroup)
        Vue.use(Switch)
        Vue.use(Divider)
        Vue.use(InputNumber)
        Vue.use(Popover)
        Vue.use(Checkbox)
        Vue.use(CheckboxGroup)
        Vue.use(ColorPicker)
        Vue.use(Cascader)
        Vue.use(Slider)
        Vue.use(Rate)
        Vue.use(Tree)
        Vue.use(Alert)
        Vue.use(RadioButton)
        Vue.component(Message)
        Vue.use(Pagination)
        Vue.use(TimeSelect)
    }
}

export default element